<template>
<div :style="tags && tags.length > 1 && fromPage !== 'listing' ? 'height:300px;overflow:auto;':''"
     @touchmove.stop="emptyFunc">
	<dl v-for="tag in tags" style="padding: 12px 12px 0">
		<dt class="fs-14 flex-container between">
            <span>{{tag}}</span>
            <div @click="imgStyle = !imgStyle" v-if="tagsValues[tag].imageUrl && tagsValues[tag].imageUrl.length">
                <div v-show="imgStyle">
                    <img src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-list.png"
                         alt="" width="16" style="margin-right: 4px;vertical-align: sub;">列表
                </div>
                <div v-show="!imgStyle">
                    <img src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-big-pic.png"
                         alt="" width="16" style="margin-right: 4px;vertical-align: sub;">大图
                </div>
            </div>
        </dt>
		<dd class="row container margint30 scroll-container" style="padding: 0;margin-top: 16px"
            v-show="tagsValues[tag].values.length > 6 && imgStyle && tag.indexOf('颜色')!==-1">
			<div v-for="(index, val) in tagsValues[tag].values.slice(0, Math.ceil(tagsValues[tag].values.length / 2))"
				  class="badge dis-i pos-r" @click="pick(tag,val)"
				  :class="[choose[tag] && val==choose[tag] ? 'active':
						(term&&term[tag]&&term[tag][val]? '': 'disabled'),
						 tagsValues[tag].imageUrl.length ? imgStyle ? 'badge-img' : 'badge-img-list' : 'badge-text']"
                  :style="{margin: tagsValues[tag].imageUrl.length && imgStyle ? '0 4px 12px' : '0 6px 12px'}"
                  style="min-width:20%;">
                <img v-if="tagsValues[tag].imageUrl && tagsValues[tag].imageUrl.length" class="img-sku"
                     :src="tagsValues[tag].imageUrl[index]" alt="" width="112" height="112">
                <img v-if="tagsValues[tag].imageUrl && tagsValues[tag].imageUrl.length && imgStyle"
                     src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-img-click.png"
                     width="20" class="pos-a left0 top0" alt="" @click.stop="skuImgClick(tagsValues[tag].imageUrl[index])">
				<span class="dis-b paddingv10 fs-14" v-text="val"></span>
			</div>
            <br/>
            <div v-for="(index, val) in tagsValues[tag].values.slice(Math.ceil(tagsValues[tag].values.length / 2), tagsValues[tag].values.length)"
                 class="badge dis-i pos-r" @click="pick(tag,val)"
                 :class="[choose[tag] && val==choose[tag] ? 'active':
						(term&&term[tag]&&term[tag][val]? '': 'disabled'),
						 tagsValues[tag].imageUrl.length ? imgStyle ? 'badge-img' : 'badge-img-list' : 'badge-text']"
                 :style="{margin: tagsValues[tag].imageUrl.length && imgStyle ? '0 4px 12px' : '0 6px 12px'}"
                 style="min-width:20%;">
                <img v-if="tagsValues[tag].imageUrl && tagsValues[tag].imageUrl.length" class="img-sku"
                     :src="tagsValues[tag].imageUrl[index + Math.ceil(tagsValues[tag].values.length / 2)]" alt="" width="112" height="112">
                <img v-if="tagsValues[tag].imageUrl && tagsValues[tag].imageUrl.length && imgStyle"
                     src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-img-click.png"
                     width="20" class="pos-a left0 top0" alt=""
                     @click.stop="skuImgClick(tagsValues[tag].imageUrl[index + Math.ceil(tagsValues[tag].values.length / 2)])">
                <span class="dis-b paddingv10 fs-14" v-text="val"></span>
            </div>
		</dd>
        <dd class="row container" style="padding: 0;margin-top: 16px"
            v-show="!(tagsValues[tag].values.length > 6 && imgStyle && tag.indexOf('颜色')!==-1)">
            <div v-for="(index, val) in tagsValues[tag].values"
                 class="badge dis-i pos-r" @click="pick(tag,val)"
                 :class="[choose[tag] && val==choose[tag] ? 'active':
						(term&&term[tag]&&term[tag][val]? '': 'disabled'),
						 tagsValues[tag].imageUrl.length ? imgStyle ? 'badge-img' : 'badge-img-list' : 'badge-text']"
                 :style="{margin: tagsValues[tag].imageUrl.length && imgStyle ? '0 4px 12px' : '0 6px 12px'}"
                 style="min-width:20%;">
                <img v-if="tagsValues[tag].imageUrl && tagsValues[tag].imageUrl.length" class="img-sku"
                     :src="tagsValues[tag].imageUrl[index]" alt="" width="112" height="112">
                <img v-if="tagsValues[tag].imageUrl && tagsValues[tag].imageUrl.length && imgStyle"
                     src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-img-click.png"
                     width="20" class="pos-a left0 top0" alt="" @click.stop="skuImgClick(tagsValues[tag].imageUrl[index])">
                <span class="dis-b paddingv10 fs-14" v-text="val"></span>
            </div>
        </dd>
	</dl>
	<div class="flex-container between" v-if="num" style="padding: 8px 12px;line-height: 20px">
		<span class="fs-16" style="white-space: nowrap">数量</span>
		<div class="flex-container right">
            <div class="text-light fs-12" v-if="saleMaxText" v-html="saleMaxText" style="margin-right: 8px"></div>
			<div style="width: 94px">
				<cmui-number :start="start" :min="min" :max="max" class="num-choose"></cmui-number>
			</div>
		</div>
	</div>
</div>
</template>
<style lang="scss">
.sku .row .badge.badge-img {
    padding: 0;
    border: none;
    border-radius: 4px;
    background: #f7f7f7;
    font-size: 14px;
    line-height: 36px;
    color: #000;
    overflow: hidden;
}
.sku .row .badge.badge-text {
    background: #f7f7f7;
    border-radius: 4px;
    color: #000;
}
.sku .row .badge.badge-img.active,
.sku .row .badge.badge-text.active{
    border: 1px solid #ff2238;
    color: #ff2238;
    background: #fff4f4;
}
.sku .row .badge.badge-img span {
    padding: 0;
}
.sku .row .badge.badge-img-list {
    padding-left: 0;
    padding-right: 12px;
    border-radius: 34px;
    background: #f7f7f7;
    color: #000;
}
.sku .row .badge.badge-img-list .img-sku {
    margin-right: 8px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    border: 1px solid #d3d3d3;
}
.sku .row .badge.badge-img-list span {
    display: inline-block;
}
.num-choose.cmui-number.form .inputGroup input {
    height: 24px;
    padding: 0 10px;
}
.num-choose.cmui-number.form .inputGroup .input_addon {
    line-height: 22px;
    width: 24px;
    min-width: 24px;
    height: 24px;
}
</style>
<script>
import {maple, domain, app} from 'tgPage';
export default {
    name: 'tg-sku',
	props: {
		sku: {
			type: Object
			, default: {
				items: []
			}
		}
		, num: {
			type: Boolean
			, default: true
		}
		, showStatus: {
			type: Boolean
			, default: false
		}
		, limit: {
			type: Number
			, default: 0
		}
		, priceLimit: {
			type: Number
			, default: 0
		},
        depot:{
            type: Boolean,
            default: true
        },
        fromPage: {
            type: String,
            default: ''
        },
        start: {
            type: Number,
            default: 1
        }
	}
	, data(){
		let data = {
				complete: false
				, tags: []
				, tagsValues: {}
				, min: 1
				// , start: 1
				, max: 999
				, maxNum: 999
				, term: {}		// 可选项
				, choose: {}	// 当前已选择
				, isAll: false,
                // sku图片样式，列表false or大图true
                imgStyle: true
			}
			, items
			;

		if( this.sku && this.sku.items && this.sku.items.length ){
			items = this.sku.items;

			data.tags = 'skuAttrMap' in items[0] ? Object.keys( items[0].skuAttrMap ) : [];

			// 统计所有条件的所有值
			data.tagsValues = this.count({
				items
				, tags: data.tags
			});

			// 数据只有一项时默认选中
			data.tags.forEach(d=>{
				if( data.tagsValues[d].values.length === 1 ){
					data.choose[d] = data.tagsValues[d].values[0];
				}
			});

			// 过滤符合已选中条件的数据
			items = items.filter(d=>{
				let rs = data.tags.reduce((is, t)=>{
					if( t in data.choose ){
						is = is && (d.skuAttrMap[t] === data.choose[t]);
					}

					return is;
				}, true);

				if( rs ){
					if( !data.choose.items ){
						data.choose.items = [];
					}
					data.choose.items.push( d );
				}
				return rs;
			});

			// 统计符合已选中条件数据的所有值
			data.term = this.count({
				items
				, tags: data.tags
			});

			data.isAll = this.tags.reduce((is, d)=>{
				return is && (d in data.choose);
			}, true);

			if( data.isAll && data.choose.items && data.choose.items.length === 1 ){
				data.max = data.choose.items[0].realRemain === -1 ? 999 : data.choose.items[0].realRemain;
				data.$dispatch('skuComplete', data.tags, data.choose.items[0].id, 1, data.choose.items[0]);
				// todo
			}
			else{
				data.isAll = false;
				data.maxNum = 1;
				data.$dispatch('skuComplete', data.tags);
			}

			if( this.limit ){	// 限购数量
				this.max = Math.min(this.maxNum, this.limit);
			}
			else{
				this.max = this.maxNum;
			}

			if( this.priceLimit ){	// 基于价格的限购数量
				this.max = Math.min(this.max, this.priceLimit );
			}
		}

		return data;
	}
	, computed: {
		saleMaxText(){
			let rs = ''
				// , temp = ''
				;

			if( this.limit && this.choose && this.choose.items && this.choose.items.length ){
				rs = '当前限购'+ this.limit +'件'
			}

			// if( this.maxNum === 999 ){
			// 	temp = '';
			// }
			// else if( this.maxNum === 0 ){
			// 	temp = '';
			// 	// temp = '库存不足';
			// }
			// else{
			// 	if( !this.isAll || ((this.maxNum === 1 && this.choose.items && this.choose.items.length !== 1) ||
			// 		/* sku 已确定选择一个，并且非本门店，数据不完整 */
			// 		(this.choose.items.length === 1 && this.choose.items[0].ext && !this.choose.items[0].data))
			// 	){
			// 		temp = '';
			// 	}
			// 	else{
			// 		// temp = '库存'+ this.maxNum +'件';
			// 		temp = '';
			// 	}
			// }

			// rs = (temp && rs ? (temp +'<br/>') : temp) + (rs ? '('+ rs +')' : '');

			return rs;
		}
	}
	, watch: {
		sku(newValue, oldValue){
            // 避免调两次查税费的接口
            if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
                return;
            }
			let items
				, tags
				, term
				, choose = {}
				, isAll = true
				, temp
				;

			if( newValue && newValue.items && newValue.items.length ){

				items = newValue.items;

				tags = 'skuAttrMap' in items[0] ? Object.keys( items[0].skuAttrMap ) : [];

				this.$set('tags', tags);

				// 统计所有条件的所有值
				this.$set('tagsValues', this.count({
					items
					, tags
				}));

				// 数据只有一项时默认选中
				tags.forEach(d=>{
					if( this.tagsValues[d].values.length === 1 ){
						choose[d] = this.tagsValues[d].values[0];
					}
				});

				// 过滤符合已选中条件的数据
				items = items.filter(d=>{
					let rs = tags.reduce((is, t)=>{
						if( t in choose ){
							is = is && (d.skuAttrMap[t] === choose[t]);
						}

						return is;
					}, true);

					if( rs ){
						if( !choose.items ){
							choose.items = [];
						}
						choose.items.push( d );
					}
					return rs;
				});

				// 统计符合已选中条件数据的所有值
				term = this.count({
					items
					, tags
				});

				this.$set('choose', choose);
				this.$set('term', term);

                if (this.fromPage !== 'listing') {
                    this.start = 1;
                }

				isAll = this.tags.reduce((is, d)=>{
					return is && (d in choose);
				}, isAll);

				this.isAll = isAll;

				if( isAll && choose.items && choose.items.length === 1 ){
					this.maxNum = choose.items[0].realRemain === -1 ? 999 : choose.items[0].realRemain;
					this.$dispatch('skuComplete', this.tags, choose.items[0].id, this.start, choose.items[0]);
					// todo
				}
				else{
					this.maxNum = 1;
					this.$dispatch('skuComplete', this.tags );
				}

				if( this.limit ){	// 限购数量
					this.max = Math.min(this.maxNum, this.limit);
				}
				else{
					this.max = this.maxNum;
				}

				if( this.priceLimit ){	// 基于价格的限购数量
					this.max = Math.min(this.max, this.priceLimit );
				}
			}
			else{
				this.$set('term', []);
				this.$set('choose', {});
				this.$set('tags', []);
				this.$set('tagsValues', []);
				this.$set('isAll', false);
			}

			if( this.choose.items && this.choose.items.length === 1 ){
				this.$dispatch('skuComplete', this.tags, this.choose.items[0].id, this.start, this.choose.items[0], choose);
			}
			else{
				this.$dispatch('skuComplete', this.tags, '', this.start, null, choose);
			}
		}
		, limit(newVal){
			if( newVal ){	// 限购数量
				this.max = Math.min(this.maxNum, newVal);
			}
			else{
				this.max = this.maxNum;
			}

			if( this.priceLimit ){	// 基于价格的限购数量
				this.max = Math.min(this.max, this.priceLimit );
			}
		}
		, priceLimit(newValue){
			if( this.limit ){	// 限购数量
				this.max = Math.min(this.maxNum, this.limit);
			}
			else{
				this.max = this.maxNum;
			}

			if( newValue ){	// 基于价格的限购数量
				this.max = Math.min(this.max, newValue );
			}
		}
	}
	, methods: {
		pick(tag, val, type){
			let items
				, temp
				, tempBig
				, choose
				, term
				, notBlank
				, isAll
				, tempIndex = {}
				;

			// 处理选择条件
			if( !(tag in this.choose) || this.choose[tag] !== val ){	// 新加或改变条件

				if( !(val in this.term[tag]) ){	// 该选项不可选
					return;
				}
				else{
					if( !(tag in this.choose) ){	// 新加入条件
						choose = this.choose;
						choose.items = [];	// 清空已选项
						choose[tag] = val;
					}
					else{	// 改变已选项
						choose = this.tags.reduce((all, d)=>{

							if( d in this.choose && d !== tag ){
								all[d] = this.choose[d];
							}

							return all;
						}, {items: []});

						choose[tag] = val;
					}
				}
			}
			else{	// 删除已选条件
				if( this.tagsValues[tag].values.length === 1 ){	// 该条件不是唯一
					return;
				}

				choose = this.tags.reduce((all, d)=>{
					if( d !== tag && d in this.choose ){
						all[d] = this.choose[d];
					}

					return all;
				}, {items: []});
			}

			// 当前所选是否为空
			notBlank = this.tags.some((d)=>{
				return d in choose;
			});

			// 是否每一个类型都被选择了
			isAll = this.tags.every((d)=>{
				return d in choose;
			});

			this.isAll = isAll;

			if( notBlank ){
				/**
				 * 统计可选择 sku 数据项
				 * */

				// 统计符合 choose 条件的选项
				items = this.tags.reduce((all, d)=>{
					if( d in choose ){
						temp = this.tagsValues[d][choose[d]];

						temp.ids.forEach((id)=>{

							if( !(id in tempIndex) ){
								let rs = this.tags.reduce((is, t)=>{
									if( t in choose && t !== d ){
										is = is && (temp[id].skuAttrMap[t] === choose[t]);	// 过滤掉库存为 0 的 sku
									}

									return is;
								}, true);

								if( rs ){
									all.push( temp[id] );
									tempIndex[id] = 1;
								}
							}
						});
					}

					return all;
				}, []);
				choose.items = items;

				// 统计符合 choose -1 条件的选项
				items = items.concat( this.tags.reduce((all, d)=>{
					if( d in choose ){
						tempBig = this.tagsValues[d];

						tempBig.values.forEach((v)=>{
							if( v !== choose[d] ){
								temp = this.tagsValues[d][v];

								temp.ids.forEach((id)=>{
									if( !(id in tempIndex) ){
										let rs = this.tags.reduce((is, t)=>{
											if( (t in choose) && (t !== d) ){
												is = is && (temp[id].skuAttrMap[t] === choose[t]);
											}
											else if( !(t in choose) ){
												is = is && items.some((p)=>{
													    return p.skuAttrMap[t] === temp[id].skuAttrMap[t];
													});
											}

											return is;
										}, true);

										if( rs ){
											all.push( temp[id] );
											tempIndex[id] = 1;
										}
									}
								});
							}
						});
					}
					console.log()

					return all;
				}, []) );
			}
			else{
				items = this.sku.items;

				choose.items = items;
			}

			// 统计符合已选中条件数据的所有值
			term = this.count({
				items
				, tags: this.tags
			});

			this.$set('term', term);
			this.$set('choose', JSON.parse(JSON.stringify(choose)));

            if (this.fromPage !== 'listing') {
                this.start = 1;
            }

            if( isAll && this.choose.items && this.choose.items.length === 1 ){
                this.maxNum = this.choose.items[0].realRemain === -1 ? 999 : this.choose.items[0].realRemain;
                this.$dispatch('skuComplete', this.tags, this.choose.items[0].id, this.start, this.choose.items[0], choose);
            }
            else{
                this.maxNum = 1;
                this.$dispatch('skuComplete', this.tags, '', this.start, null, this.choose);
            }

            // 通知app进行联动
            if (!type && maple.cookie('hybrid') && app.getTgAppVersion() >= 20241126) {
                app.clickedProductSku({tag, val});
            }

			if( this.limit ){	// 限购数量
				this.max = Math.min(this.maxNum, this.limit);
			}
			else{
				this.max = this.maxNum;
			}

			if( this.priceLimit ){	// 基于价格的限购数量
				this.max = Math.min(this.max, this.priceLimit );
			}
		}
		, emptyFunc(){},
        /**
         * 删掉库存为0
         * @param	{Array}	items		sku 数组
         * @param	{Array}	tags		sku 标签数组
         * */
        count({items, tags}){
            return tags.reduce((all, d)=>{
                all[d] = items.reduce((a, t)=>{
                    if( !(t.skuAttrMap[d] in a) ){
                        a.values.push( t.skuAttrMap[d] );
                        if (d.indexOf('颜色') !== -1 && t.imageUrl) {
                            a.imageUrl.push(t.imageUrl)
                        }
                        a[t.skuAttrMap[d]] = {
                            ids: []
                        };
                    }
                    if (t.remainQty || (this.depot)) {
                        a[t.skuAttrMap[d]][t.id] = t;
                        a[t.skuAttrMap[d]].ids.push( t.id );
                    }
                    return a;
                }, {values: [], imageUrl: []});
                if (all[d].values.length !== all[d].imageUrl.length) {
                    all[d].imageUrl = [];
                }
                return all;
            }, {});
        },
        skuImgClick(imgUrl){
            this.$dispatch('skuImgClick', imgUrl);
        },
        setNum(num) {
            this.start = num;
        }
	}
	, events: {
		numChange(target, num){
			this.start = num;

			if( this.isAll && this.choose.items.length && num < (this.choose.items[0].realRemain === -1 ? 999 : this.choose.items[0].realRemain) ){
				this.$dispatch('skuComplete', this.tags, this.choose.items[0].id, this.start, this.choose.items[0], this.choose);
			}
			else if( this.choose.items.length === 1 ){
				this.$dispatch('skuComplete', this.tags, this.choose.items[0].id, this.start, this.choose.items[0], this.choose, 'numChange');
			}
		}
		, refreshMaxNum(){
			if( this.choose && this.choose.items && this.choose.items.length === 1 ){
				this.maxNum = this.choose.items[0].realRemain === -1 ? 999 : this.choose.items[0].realRemain;

				if( this.limit ){	// 限购数量
					this.max = Math.min(this.maxNum, this.limit);
				}
				else{
					this.max = this.maxNum;
				}

				if( this.priceLimit ){	// 基于价格的限购数量
					this.max = Math.min(this.max, this.priceLimit );
				}
			}
		}
	}
};
</script>